export const SIMS_FETCH = 'moi/sims/SIMS_FETCH';
export const SIM_UPDATE = 'moi/sims/SIM_UPDATE';
export const SIM_INFO_UPDATE = 'moi/sims/SIM_INFO_UPDATE';
export const SIMS_RECEIVE = 'moi/sims/SIMS_RECEIVE';
export const UPDATE_ORDER = 'moi/sims/UPDATE_ORDER';
export const UPDATE_ORDER_FINISHED = 'moi/sims/UPDATE_ORDER_FINISHED';
export const CURRENT_ORDER_FETCH = 'moi/sims/CURRENT_ORDER_FETCH';
export const CURRENT_ORDER_RECEIVE = 'moi/sims/CURRENT_ORDER_RECEIVE';
export const CURRENT_SIM_FETCH = 'moi/sims/CURRENT_SIM_FETCH';
export const CURRENT_SIM_RECEIVE = 'moi/sims/CURRENT_SIM_RECEIVE';
export const CURRENT_SIM_CLEAR = 'moi/sims/CURRENT_SIM_CLEAR';
export const CURRENT_SIM_POLL = 'moi/sims/CURRENT_SIM_POLL';
export const NON_ACTIVATED_SIMS_FETCH = 'moi/sims/NON_ACTIVATED_SIMS_FETCH';
export const NON_ACTIVATED_SIMS_RECEIVE = 'moi/sims/NON_ACTIVATED_SIMS_RECEIVE';
export const SUBMIT_NUMSI = 'moi/sims/SUBMIT_NUMSI';
export const SUBMIT_NUMSI_FINISHED = 'moi/sims/SUBMIT_NUMSI_FINISHED';
